/**
 * Coordinates mute state across all videos in the app.
 * Only one video can be unmuted at a time.
 */

type MuteCallback = () => void;

let currentlyUnmutedVideoMute: MuteCallback | null = null;

/**
 * Registers a video as unmuted. If another video was unmuted, it will be muted first.
 * @param muteCallback - Function to call to mute this video
 */
export const registerUnmutedVideo = (muteCallback: MuteCallback): void => {
  // Mute the previously unmuted video
  if (currentlyUnmutedVideoMute && currentlyUnmutedVideoMute !== muteCallback) {
    currentlyUnmutedVideoMute();
  }
  currentlyUnmutedVideoMute = muteCallback;
};

/**
 * Unregisters a video from being the current unmuted video.
 * @param muteCallback - The mute callback that was registered
 */
export const unregisterUnmutedVideo = (muteCallback: MuteCallback): void => {
  if (currentlyUnmutedVideoMute === muteCallback) {
    currentlyUnmutedVideoMute = null;
  }
};
export const muteCurrentVideo = (): void => {
  currentlyUnmutedVideoMute?.();
  currentlyUnmutedVideoMute = null;
};
